
interface FilterTabsProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

export default function FilterTabs({ activeFilter, onFilterChange }: FilterTabsProps) {
  const filters = [
    { id: 'all', label: 'All Guidelines', icon: 'ri-file-list-3-line', color: 'bg-blue-600' },
    { id: 'Fannie Mae', label: 'Fannie Mae', icon: 'ri-home-4-line', color: 'bg-emerald-600' },
    { id: 'Freddie Mac', label: 'Freddie Mac', icon: 'ri-building-line', color: 'bg-violet-600' },
    { id: 'HUD', label: 'HUD/FHA', icon: 'ri-government-line', color: 'bg-amber-600' },
    { id: 'VA', label: 'VA', icon: 'ri-shield-star-line', color: 'bg-rose-600' }
  ];

  return (
    <div className="flex flex-wrap gap-3 mb-8">
      {filters.map((filter) => (
        <button
          key={filter.id}
          onClick={() => onFilterChange(filter.id === 'all' ? '' : filter.id)}
          className={`px-6 py-3 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2 hover:scale-105 ${
            (activeFilter === filter.id || (activeFilter === '' && filter.id === 'all'))
              ? `${filter.color} text-white shadow-lg shadow-black/20`
              : 'bg-slate-700 text-slate-300 hover:bg-slate-600 border border-slate-600'
          }`}
        >
          <i className={`${filter.icon} w-4 h-4 flex items-center justify-center`}></i>
          {filter.label}
        </button>
      ))}
    </div>
  );
}
